import {Tabs as TabsBase} from '@yandex-delivery/blocks'
import {useController, useFormContext} from '@yandex-delivery/form'
import React from 'react'

import {classes} from './Tabs.classes'
import type {Props} from './Tabs.types'

export function Tabs({name, size = 'm', items = [], defaultValue, onChange}: Props): React.ReactElement {
  const {control} = useFormContext()
  const {field} = useController({control, name, defaultValue})

  function changeHandler(newValue: string) {
    field.onChange(newValue)
    onChange?.(newValue)
  }

  return (
    <TabsBase.Segments
      className={classes.root}
      items={items}
      onChange={changeHandler}
      size={size}
      value={field.value}
    />
  )
}
